(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-media-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initBbmc(root){
    (root||document).querySelectorAll('[data-bbmc-track]').forEach(function(track){
      if(track.dataset.bbmcInit) return; track.dataset.bbmcInit='1';
      var nav=track.parentElement.querySelector('[data-bbmc-nav]');
      var btns=nav?nav.querySelectorAll('button'):[];
      function update(){
        var over=track.scrollWidth>track.clientWidth+2;
        track.classList.toggle('is-overflowing',over);
        if(nav){ nav.hidden=!over;
          if(btns.length){ btns[0].disabled=track.scrollLeft<=2; btns[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2; } }
      }
      Array.prototype.forEach.call(btns,function(b){ b.addEventListener('click',function(){
        var tile=track.querySelector('.bbmc__tile');
        var step=tile?tile.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap||0):track.clientWidth;
        track.scrollBy({left:step*Number(b.dataset.dir),behavior:'smooth'}); }); });
      track.addEventListener('scroll',function(){ window.requestAnimationFrame(update); },{passive:true});
      window.addEventListener('resize',update); update();
      var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.querySelectorAll('[data-bbmc-video]').forEach(function(v){
        v.muted=true; v.defaultMuted=true; v.removeAttribute('controls');
        if(reduce){ v.removeAttribute('autoplay'); v.pause(); return; }
        if('IntersectionObserver' in window){
          new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); } else { v.pause(); } }); },{threshold:0.25}).observe(v);
        } else { v.play(); }
      });
    });
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',function(){ initBbmc(); }); } else { initBbmc(); }
  document.addEventListener('shopify:section:load',function(e){ initBbmc(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
